<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                user_item_caches_id: [],
                user_item_caches: {},
                user_item_caches_sku: {},
                margin: 0,
                status: 'activated',
                is_single: true,
                details: {
                    amazon: {
                        shipping_speed_category: 'Standard',
                    },
                    woo: {
                        sync_data: '',
                    },
                },
                listings: {
                    ebay: {
                        title: '',
                        category_id: '',
                        item_specifics: [],
                    },
                },
                filters: {
                    country: null,
                },
            }"
            :filters-default="{
                status: '',
                sort: '-ordered_at',
            }"
            :filter-items="[
                {
                    vModel: 'is_canceled',
                    title: 'キャンセル',
                    options: [
                        { text: '全て', value: '' },
                        { text: 'キャンセル', value: '1' },
                        { text: '通常', value: '0' },
                    ],
                },
                {
                    vModel: 'is_deleted',
                    title: '同期解除',
                    options: [
                        { text: '全て', value: '' },
                        { text: '同期解除', value: '1' },
                        { text: '通常', value: '0' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲注文日時', value: 'ordered_at' },
                        { text: '▼注文日時', value: '-ordered_at' },
                    ],
                },
            ]"
            filters-q-placeholder="注文番号、追跡番号"
            form-modal-id="user_order"
            search-action="user_order/index"
            row-class="flex-nowrap mx-0 my--2"
            :hide-table="true"
            :hide-add="true"
            >

            <template v-slot:form="{ form, init }">
                <UserOrder
                    :model="form"
                    :init="init"
                    @save="$refs.gridPage.save"
                    @destroy="$refs.gridPage.destroy"
                    />
            </template>

            <template v-slot:after-table>
                <template v-if="$refs.gridPage && $refs.gridPage.grid.response.data && $refs.gridPage.grid.response.data.hits && $refs.gridPage.grid.response.data.hits.length">
                    <div class="table-wrapper mt-3">
                        <table class="table table-bordered table-hover">
                            <thead class="thead-dark">
                                <tr style="
                                    position: -webkit-sticky;
                                    position: sticky;
                                    top: 0;
                                    z-index: 1;
                                    ">
                                    <th class="sticky-header" style="width: 12em;">Store</th>
                                    <th class="sticky-header" style="width: auto;">Inventory</th>
                                    <th class="sticky-header" style="width: 12em;">注文日時</th>
                                    <th class="sticky-header" style="width: 18em;">出荷日時/追跡番号</th>
                                    <th class="sticky-header" style="width: 12em;">キャンセル日時</th>
                                    <th class="sticky-header" style="width: 12em;">同期解除日時</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in $refs.gridPage.grid.response.data.hits"
                                    :key="item.uuid"
                                    @click="$refs.gridPage.detail(item)"
                                    >
                                    <td>
                                        <small>
                                            {{ item.store_id }}@{{ item.store_provider }}
                                        </small>
                                        <br>
                                        {{ item.store_order_id }}
                                    </td>
                                    <td>
                                        <small>
                                            {{ item.inventory_id }}@{{ item.inventory_provider }}
                                        </small>
                                        <br>
                                        {{ item.inventory_order_id }}
                                    </td>
                                    <td>{{ item.ordered_at }}</td>
                                    <td>
                                        {{ item.shipped_at }}<br>
                                        <div v-for="code in (item.tracking_codes || [])">
                                            <small>
                                                {{ code.number }}@{{ code.carrier }}
                                            </small>
                                        </div>
                                    </td>
                                    <td>{{ item.canceled_at }}</td>
                                    <td>{{ item.deleted_at }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import UserOrder from '@/components/UserOrder.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'

export default {
    components: {
        GridPage,
        UserOrder,
        ItemBadges,
        ItemThumb,
        ItemInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {
            _: {
                sync_ebay_order_id: '',
                add_bulk_file: null,
            },
        }
    },
    methods: {
        async addBulk() {
            this.$bvModal.show('modal-add-bulk');
        },
        async onClickAddBulkRun() {
            console.log(this.$data._.add_bulk_file);
            this.$store.dispatch('item/save_bulk', { file: this.$data._.add_bulk_file })
                .then((response) => {
                    this.$bvModal.hide('modal-add-bulk');
                    this.$refs.gridPage.search();
                    return response
                })
                .catch((error) => {
                    this.$data._.add_bulk_file = null;
                    return Promise.reject(error.response.data.errors || {})
                })
        },
        async onClickAddBulkSample() {
            let data = {};

            // columns
            data.columns = [
                'status',
                'is_single',
                'user_item_caches_id.amazon',
                'user_item_caches_id.ebay',
                'margin',
                'condition_to_replenish',
                'max',
                'details.amazon.shipping_speed_category',
            ];

            // rows
            data.rows = [
                {
                    status: 'activated',
                    is_single: 1,
                    'user_item_caches_id.amazon': '11111',
                    'user_item_caches_id.ebay': '11111',
                    margin: 0,
                    condition_to_replenish: null,
                    max: null,
                    'details.amazon.shipping_speed_category': 'Standard',
                },
                {
                    status: 'activated',
                    is_single: 0,
                    'user_item_caches_id.amazon': '22222',
                    'user_item_caches_id.ebay': '22222',
                    margin: 10,
                    condition_to_replenish: null,
                    max: 5,
                    'details.amazon.shipping_speed_category': 'Expedited',
                },
                {
                    status: 'suspended',
                    is_single: 0,
                    'user_item_caches_id.amazon': '33333',
                    'user_item_caches_id.ebay': '33333',
                    margin: 10,
                    condition_to_replenish: 3,
                    max: 5,
                    'details.amazon.shipping_speed_category': 'Priority',
                },
            ];

            const response = await this.$store
                .dispatch('insurance/download_js', data);

            if (!response || response.length === 0) {
                alert('CSV作成失敗');
                return;
            }

            const blob = new Blob([response], { type: 'text/csv' });
            const anchor = document.createElement('a');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.target = '_blank';
            anchor.download = 'data_sync_sample.csv';
            anchor.click();
        },
        async listItem(item, provider) {
console.log(item)
console.log(provider)
            let provider_type = null
            switch (provider) {
                case 'amazon':
                    provider_type = 'inventory'
                    break
                case 'ebay':
                    provider_type = 'store'
                    break
            }

            await this.$store
                .dispatch('item/list_item', { uuid: item.uuid, provider: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
        onClickSyncEbayOrderManually() {
            this.$bvModal.show('modal-sync-ebay-order-manually')
        },
        async onClickSyncEbayOrderManuallyRun() {
            await this.$store
                .dispatch('item/sync_ebay_order_manually', { order_id: this.$data._.sync_ebay_order_id, })
                .then((response) => {
console.log(response)
                    this.$bvModal.hide('modal-sync-ebay-order-manually')
                })
                .catch((error) => {
                })

        },
    },
}
</script>

